import { render, staticRenderFns } from "./DownloadDoc.vue?vue&type=template&id=7caf40f2"
import script from "./DownloadDoc.vue?vue&type=script&lang=js"
export * from "./DownloadDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports